import { get,put,post,del } from "./index";
export function getList(params) {
    return get('/api/admin/video', params);
}
export function update(id, params) {
    return put(`/api/admin/video/${id}`, params);
}
export function add(params) {
    return post('/api/admin/video', params);
}
export function getDetails(id) {
    return put(`/api/admin/video/${id}`);
}
export function strike(id) {
    return del(`/api/admin/video/${id}`);
}

export function getReview(data) {
    return post('/api/admin/video/review', data);
}
export function updateReview(id, data) {
    return put(`/api/admin/video/review/${id}`, data);
}